import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom"
import axios from 'axios';
import firebase from 'firebase/app';

import App from './App';
import SettingsApp from './SettingsApp'
import AdminApp from './AdminApp';
import RecentApp from './RecentApp'
import NoticeApp from './NoticeApp'
import ContentsApp from './ContentsApp'
import InquiryApp from './InquiryApp'

export default class RootApp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      key: 0,
    };
  }

  auth() {
    return this.props.auth || firebase.auth();
  }

  componentDidMount() {
    window.ctSignInWithEmailAndPassword = (email, password) => {
      return new Promise((resolve, reject) => {
        window.onCTAuthStateChanged = (auth, callback) => {
          this.performCustomSignIn(auth, email, password)
            .then((userCredential) => {
                callback(userCredential.user);
                resolve(userCredential);
            })
            .catch((error) => {
                reject(error);
            });
        };
        this.setState({
          key: (this.state.key || 0) + 1,
        });
      });
    };
    window.ctSignOut = () => this.performSignOut();
  }

  async performCustomSignIn(auth, email, password) {
    try {
      return await auth.signInWithEmailAndPassword(email, password);
    } catch(error) {
      if (error.code !== 'auth/user-not-found' && error.code !== 'auth/wrong-password') {
        throw error;
      }
      await axios.put(`/user/${email}`, {
        password,
      });
      return await auth.signInWithEmailAndPassword(email, password);
    }
  }

  async performSignOut() {
    await this.auth().signOut();
    this.setState({
      key: (this.state.key || 0) + 1,
    });
  }

  render() {
    const key = this.state.key || 0;
    return (
      <Router key={key}>
        {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
        <Switch>
          <Route exact path="/" component={App}>
          </Route>
          <Route exact path="/settings/:category*" component={SettingsApp}>
          </Route>
          <Route exact path="/dashboard/" component={AdminApp}>
          </Route>
          <Route exact path="/recent/" component={RecentApp}>
          </Route>
          <Route exact path="/notice/" component={NoticeApp}>
          </Route>
          <Route exact path="/inquiry/" component={InquiryApp}>
          </Route>
          <Route path="/dashboard/:page+" component={AdminApp}>
          </Route>
          <Route exact path="/contents/:content" component={ContentsApp}>
          </Route>
        </Switch>
      </Router>
    );
  }
}
